import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import MeterianMappingForm from "./MeterianMappingForm";

function MeterianCredentialsForm(props, ref) {
  const fields = [
    {
      name: "apiToken",
      label: "Api Token",
      required: true,
      type: FieldTypes.PASSWORD,
    },
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      rules: [urlRegexValidator],
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={MeterianMappingForm}
      initialValue={{ apiEndpoint: 'https://meterian.com' }}
    />
  );
}

export default forwardRef(MeterianCredentialsForm);
